<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-aed-ownerChange"
    >
      <div slot="header">
        <h2
          class="o-heading o-heading--size-2 o-heading--border"
          v-if="step === 1"
        >
          {{ translationsOwnerModal.moveAEDto }}
        </h2>
        <h2
          class="o-heading o-heading--size-2 o-heading--border"
          v-if="step === 2"
        >
          {{ translationsOwnerModal.moveOtherAEDs }}
        </h2>
        <h2
          class="o-heading o-heading--size-2 o-heading--border"
          v-if="step === 3 && !newOwner.isValid"
        >
          {{ selectedItems.length }} {{ translationsOwnerModal.aedWasMovedTo }}
          {{ selectedOwner.name }}
          {{ selectedOwner.secondaryName }}
        </h2>
        <h2
          class="o-heading o-heading--size-2 o-heading--border"
          v-if="step === 3 && newOwner.isValid"
        >
          {{ selectedItems.length }} {{ translationsOwnerModal.aedWasMovedTo }}
          {{ newOwner.firstName }}
          {{ newOwner.lastName }}
        </h2>
      </div>
      <div slot="body">
        <div class="o-grid o-grid--gutter-normal" v-if="step === 1">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <CallCenterAEDownerSearch
                :currentOwnerId="this.profileAedCount.profile"
              ></CallCenterAEDownerSearch>
            </div>
            <div class="o-grid__item o-grid__item--12">
              <CallCenterAEDownerCreate></CallCenterAEDownerCreate>
            </div>
          </div>
        </div>
        <div class="o-grid o-grid--gutter-normal" v-if="step === 2">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <CallCenterAEDownerOtherAED></CallCenterAEDownerOtherAED>
            </div>
          </div>
        </div>
        <div
          class="o-grid o-grid--gutter-normal"
          v-if="step === 3 && newOwner.isValid"
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-aed-adminChange__text-label o-heading o-heading--size-4"
              >
                {{ translationsOwnerModal.newOwnerNeedsToAcceptBefore }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="o-grid o-grid--gutter-small">
          <div class="o-grid__group">
            <div
              class="c-aed-ownerChange__footer-item o-grid__item o-grid__item--grow-0"
              v-if="step === 1"
            >
              <button
                class="o-button"
                :disabled="canNavigateNext"
                @click="navigateNext"
              >
                {{ translationsOwnerModal.moveAED }}
              </button>
            </div>
            <div
              class="c-aed-ownerChange__footer-item o-grid__item o-grid__item--grow-0"
              v-if="step === 2 && canNavigateNext"
            >
              <button class="o-button" @click="navigateNext">
                {{ moveMarkedText }}
              </button>
            </div>
            <div
              class="c-aed-ownerChange__footer-item o-grid__item o-grid__item--grow-0"
              v-if="step === 3 && !newOwner.isValid"
            >
              <button class="o-button" @click="navigateNext">
                {{ translationsCustom.ok }}
              </button>
            </div>
            <div
              class="c-aed-ownerChange__footer-item o-grid__item o-grid__item--grow-0"
              v-if="step === 3 && newOwner.isValid"
            >
              <button class="o-button" @click="navigateNext">
                {{ translationsCustom.ok }}
              </button>
            </div>
            <div
              class="c-aed-ownerChange__footer-item o-grid__item o-grid__item--grow-0"
              v-if="step === 1"
            >
              <button
                class="o-button o-button--transparent"
                @click="closeModal()"
              >
                {{ translationsCustom.cancel || "" }}
              </button>
            </div>
            <div
              class="c-aed-ownerChange__footer-item o-grid__item o-grid__item--grow-0"
              v-if="step === 2"
            >
              <button
                class="o-button o-button--transparent"
                @click="navigateNext"
                @keyup.enter="navigateNext"
              >
                {{ translationsOwnerModal.skipThis || "" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import CallCenterAEDownerSearch from "@/components/AED/aed-ownerSearch.vue";
import CallCenterAEDownerCreate from "@/components/AED/aed-ownerCreate.vue";
import CallCenterAEDownerOtherAED from "@/components/AED/aed-ownerOtherAED.vue";
export default {
  data() {
    return {
      section: "assignee",
      name: "Skift ejer",
      showModal: false
    };
  },
  components: {
    CallCenterAEDownerSearch,
    CallCenterAEDownerCreate,
    CallCenterAEDownerOtherAED
  },
  props: {
    showOwnerChange: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters("aed", ["profileAedCount", "currentAED", "parameters"]),
    ...mapState("owners", [
      "owners",
      "selectedOwner",
      "selectedItems",
      "newOwner",
      "step",
      "currentOwnerItems"
    ]),
    ...mapState("translations", {
      translationsOwnerModal: "ownerModal",
      translationsCustom: "custom"
    }),
    canNavigateNext() {
      const conditions = {
        cond1: this.selectedOwner === undefined && !this.newOwner.isValid,
        cond2: this.selectedItems.length - 1 > 0
      };

      return conditions[`cond${this.step}`];
    },
    moveMarkedText() {
      const count = this.selectedItems.length - 1;
      const text = `${this.translationsOwnerModal.yesMoveThe} ${count} ${
        this.translationsOwnerModal.markedAED
      }${count > 1 ? "e" : ""}`;

      return text;
    }
  },
  methods: {
    ...mapActions("owners", ["createOrupdate", "getCurrentOwnersItems"]),
    ...mapMutations("owners", ["addSelectedItem", "resetState", "nextStep"]),
    closeModal() {
      this.showModal = false;
      this.$emit("close");
    },
    navigateNext() {
      switch (this.step) {
        case 1: {
          if (this.currentOwnerItems.length > 1) {
            this.nextStep();
          } else {
            this.handleAEDmove();
          }
          break;
        }
        case 2: {
          this.handleAEDmove();
          break;
        }
        case 3: {
          this.closeModal();
          break;
        }
      }
    },
    handleOwnerSelect() {
      if (this.selectedOwner !== undefined || this.newOwner.isValid) {
        this.nextStep();
      }
    },
    handleAEDmove() {
      const payload = {
        profile: this.selectedOwner && this.selectedOwner.id,
        getAllpayload: {
          id: this.$store.state.aed.all.id,
          parameters: this.parameters
        },
        aed: this.selectedItems,
        newOwnerData: this.newOwner,
        newOwner: this.newOwner.isValid
      };

      this.createOrupdate(payload);
    }
  },
  created() {
    const payload = {
      profileId: this.profileAedCount.profile
    };
    this.getCurrentOwnersItems(payload);
    this.addSelectedItem(this.currentAED);
    this.$nextTick(() => {
      this.showModal = this.showOwnerChange;
    });
  },
  destroyed() {
    this.resetState();
  }
};
</script>

<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-aed-ownerChange {
  .c-modal__body {
    margin-bottom: 40px;
  }
  .c-modal__footer {
    background-color: $s-cp-neutral-700;
    padding-top: 30px;
    padding-bottom: 40px;
  }
}
</style>
